var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossBrowser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 2.25V11.25H12.375V13.5H1.6875C0.738281 13.5 0 12.7617 0 11.8125C0 11.5312 0.246094 11.25 0.5625 11.25H2.25V2.25C2.25 1.01953 3.23438 0 4.5 0H15.75C16.9805 0 18 1.01953 18 2.25V3.375H16.3125V2.25C16.3125 1.96875 16.0312 1.6875 15.75 1.6875H4.5C4.18359 1.6875 3.9375 1.96875 3.9375 2.25ZM20.25 4.5C21.4805 4.5 22.5 5.51953 22.5 6.75V15.75C22.5 17.0156 21.4805 18 20.25 18H15.75C14.4844 18 13.5 17.0156 13.5 15.75V6.75C13.5 5.51953 14.4844 4.5 15.75 4.5H20.25ZM20.8125 15.75V6.75C20.8125 6.46875 20.5312 6.1875 20.25 6.1875H15.75C15.4336 6.1875 15.1875 6.46875 15.1875 6.75V15.75C15.1875 16.0664 15.4336 16.3125 15.75 16.3125H20.25C20.5312 16.3125 20.8125 16.0664 20.8125 15.75Z",
    fill: "#5959EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBrowser);
export default __webpack_public_path__ + "static/media/CrossBrowser.af694d022060846c761787dcce790edc.svg";
export { ForwardRef as ReactComponent };